import InterfacePreferences from 'localization/InterfacePreferences'
import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { Link, Navigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ArrowLeft } from 'lucide-react'
import logo from 'assets/img/fav.png'
import DriverRegistrationForm from 'components/Forms/DriverRegistrationForm/DriverRegistrationForm'
import { Layout } from 'components'
import styles from 'pages/Login/Auth.module.scss'
export default function DriverRegistration({ adminMode = false }) {
  useInterfaceLanguage();
  const user = useSelector(state => state.user)
  const [params] = useSearchParams()
  const editing = params.get('edit') === '1'
  if (editing && !user.userId) return <Navigate to="/" replace />
  const mode = adminMode ? 'admin' : editing ? 'edit' : 'public'
  if (mode !== 'public') return <Layout><div style={{ maxWidth: 860, margin: '0 auto' }}><DriverRegistrationForm mode={mode} /></div></Layout>
  return <div className={'erp-auth ' + styles.page}><InterfacePreferences placement="auth" /><Link to="/" className={styles.brand}><img src={logo} alt={tr("Логотип Кыргызкомур")} /><span><strong>{tr("Кыргызкомур")}</strong><small>{tr("Управление логистикой")}</small></span></Link><main className={styles.registrationMain}><Link to="/" className={styles.link}><ArrowLeft size={14} />{tr("На страницу входа")}</Link><DriverRegistrationForm /></main><footer className={styles.footer}><span>{tr("ОАО «Кыргызкомур»")}</span><span>{tr("Центр управления и контроля логистики")}</span></footer></div>
}
